module.exports = __webpack_public_path__ + "static/media/chef.ae9e9ac9.png";